<script setup>
const props = defineProps(["class"]);
</script>

<template>
	<svg
		width="16"
		height="17"
		viewBox="0 0 16 17"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		:class="class"
	>
		<path
			d="M6.6668 9.16794C6.9531 9.5507 7.31837 9.8674 7.73783 10.0966C8.1573 10.3257 8.62114 10.462 9.0979 10.4962C9.57466 10.5303 10.0532 10.4615 10.501 10.2945C10.9489 10.1274 11.3555 9.86599 11.6935 9.52794L13.6935 7.52794C14.3007 6.89927 14.6366 6.05726 14.629 5.18327C14.6215 4.30929 14.2709 3.47324 13.6529 2.85522C13.0348 2.23719 12.1988 1.88663 11.3248 1.87903C10.4508 1.87144 9.60881 2.20742 8.98013 2.81461L7.83347 3.95461M9.33347 7.83461C9.04717 7.45186 8.6819 7.13516 8.26243 6.90599C7.84297 6.67681 7.37913 6.54053 6.90237 6.50639C6.4256 6.47225 5.94708 6.54103 5.49924 6.70809C5.0514 6.87515 4.64472 7.13657 4.3068 7.47461L2.3068 9.47461C1.69961 10.1033 1.36363 10.9453 1.37122 11.8193C1.37881 12.6933 1.72938 13.5293 2.3474 14.1473C2.96543 14.7654 3.80147 15.1159 4.67546 15.1235C5.54945 15.1311 6.39146 14.7951 7.02013 14.1879L8.16013 13.0479"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="square"
		/>
	</svg>
</template>
